/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * @example
 *     {}
 */
export interface SchemaPublishRequest {
    /** Slug of a CredentialSchema. */
    slug?: string;
    /** The version of the resource. */
    version?: number;
}
